import React from 'react';
import { Users } from 'lucide-react';
import { formatAmount } from '../utils/format';

const LoanItem = ({ loan, onClick }) => {
  const balance = parseFloat(loan.balance) || 0;
  const isOwed = balance > 0;

  return (
    <button
      onClick={onClick}
      className="w-full bg-white rounded-xl p-4 shadow-sm hover:bg-gray-50 transition"
    >
      <div className="flex justify-between items-center">
        <div className="flex items-center space-x-3">
          <div className={`p-2 rounded-full ${isOwed ? 'bg-green-100' : 'bg-red-100'}`}>
            <Users className={`w-5 h-5 ${isOwed ? 'text-green-600' : 'text-red-600'}`} />
          </div>
          <div className="text-left">
            <p className="font-medium text-gray-800">{loan.entity || 'Unknown'}</p>
            <p className="text-xs text-gray-500 capitalize">
              {loan.description || (isOwed ? 'owes you' : 'you owe')}
            </p>
          </div>
        </div>
        <p className={`font-bold text-lg ${isOwed ? 'text-green-600' : 'text-red-600'}`}>
          ${formatAmount(balance)}
        </p>
      </div>
    </button>
  );
};

export default LoanItem;
